import { useGoogleMaps } from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import { MapIcon } from '@airship-platform/jam-web/icons';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Appointment } from '../../../../data-access/appointments';

type AddressProps = {
  location: Appointment['location'];
};

const Address: React.FC<AddressProps> = ({ location }) => {
  const { getStreetViewUrl, getStaticMapUrl } = useGoogleMaps();
  const fullAddress = `${location.address1}, ${location.city}, ${location.state} ${location.zip}`;

  const addressLocation = () =>
    location.latitude && location.longitude
      ? `${location.latitude},${location.longitude}`
      : fullAddress;

  return (
    <FlexBox flexDirection={'column'} gap={3}>
      <Typography variant="h4">Address</Typography>
      <FlexBox
        flexDirection={['column', 'row']}
        alignItems={['flex-left', 'center']}
        gap={2}
        justifyContent={'space-between'}
      >
        <FlexBox flexDirection={'column'}>
          <Typography variant="subtitle1">{location.address1}</Typography>
          <Typography variant="subtitle1">{`${location.city}, ${location.state} ${location.zip}`}</Typography>
        </FlexBox>
        <Button
          color="softGold"
          target="_blank"
          size="large"
          href={`https://maps.google.com/maps/search/?q=${fullAddress}`}
          startIcon={<MapIcon />}
        >
          Directions
        </Button>
      </FlexBox>
      <FlexBox
        flexDirection={['column', 'row']}
        flex={1}
        gap={[2, 1]}
        maxWidth={'100%'}
      >
        <Box
          component={'img'}
          src={getStaticMapUrl(addressLocation())}
          sx={{
            flex: 1,
            borderRadius: ['0.5rem', '0.5rem 0 0 0.5rem'],
            maxWidth: ['100%', '50%'],
          }}
        />
        <Box
          component={'img'}
          src={getStreetViewUrl(addressLocation())}
          sx={{
            flex: 1,
            borderRadius: ['0.5rem', '0 0.5rem 0.5rem 0'],
            maxWidth: ['100%', '50%'],
          }}
        />
      </FlexBox>
    </FlexBox>
  );
};

export default Address;
